import { render } from "./RecipientInput.vue?vue&type=template&id=e72337d2&scoped=true"
import script from "./RecipientInput.vue?vue&type=script&lang=js"
export * from "./RecipientInput.vue?vue&type=script&lang=js"

import "./RecipientInput.vue?vue&type=style&index=0&id=e72337d2&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e72337d2"]])

export default __exports__